export default __webpack_public_path__ + "static/media/cpLogo.f4296945.png";